<template>
    <Page>
        <PageHeader back="dashboard">
            {{ $t('pageTitle') }}
        </PageHeader>

        <div v-if="! large">
            <div class="page-icon">
                <IconProfile classes="mx-auto" height="75" />
            </div>
            <NameEditable />
            <LoadingButton @clicked="logout">{{ $t('logout') }}</LoadingButton>
        </div>
        <div class="page-container double settings large" v-if="large">
            <div class="">
                <NameEditableLarge />
                <EmailEditable />
                <PasswordEditable />
            </div>
            <div class="">
                <Subscription />
                <CityEditable />
                <BirthEditable v-if="canUse('personal-auspiciousness')" />
            </div>
        </div>

        <template v-slot:bottom>
            <div class="settings" v-if="! large">
                <EmailEditable />
                <CityEditable />
                <BirthEditable v-if="canUse('personal-auspiciousness')" />
                <PasswordEditable />
                <Subscription />
                <NightMode />
                <Oferta />
            </div>
            <div v-if="large">
                <LoadingButton @clicked="logout">{{ $t('logout') }}</LoadingButton>
                <div class="settings">
                    <NightMode />
                    <Oferta />
                </div>
            </div>
        </template>
    </Page>
</template>

<script>
import IconProfile from '@/components/visual/icons/IconProfile'
import LoadingButton from '@/components/visual/LoadingButton'
import PageHeader from '@/components/visual/PageHeader'
import Page from '@/components/visual/Page'
import EmailEditable from '@/components/settings/EmailEditable'
import CityEditable from '@/components/settings/CityEditable'
import BirthEditable from '@/components/settings/BirthEditable'
import NameEditable from '@/components/settings/NameEditable'
import NameEditableLarge from '@/components/settings/NameEditableLarge'
import NightMode from '@/components/settings/NightMode'
import PasswordEditable from '@/components/settings/PasswordEditable'
import Subscription from '@/components/settings/Subscription'
import Oferta from '@/components/settings/Oferta'
import { mapState, mapGetters } from 'vuex'

export default {
    components: { Page, PageHeader, EmailEditable, CityEditable, BirthEditable, NameEditable, NameEditableLarge, PasswordEditable, IconProfile, Subscription, NightMode, LoadingButton, Oferta },
    data() {
        return {
            large: undefined,
        }
    },
    created() {
        this.checkSize()
        window.addEventListener("resize", this.checkSize)
    },
    destroyed() {
        window.removeEventListener("resize", this.checkSize)
    },
    methods: {
        logout() {
            this.$store.dispatch('auth/logout')
                .then(() => {
                    this.$router.push({ name: 'home' })
                })
        },
        checkSize() {
            this.large = window.innerWidth > 1024
        },
    },
    computed: {
        ...mapGetters('errors', {errorsHappened: 'happened'}),
        ...mapGetters('auth', ['canUse']),
        ...mapState('auth', ['user']),
    },
}
</script>

<i18n locale="ru" lang="yaml">
  pageTitle: "Профиль"
  logout: "Выйти"
</i18n>

<i18n locale="en" lang="yaml">
  pageTitle: "Profile"
  logout: "Logout"
</i18n>
